var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _ellipse2, _ellipse3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#262826"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6503 23.378C58.6867 18.6558 52.1869 21.3091 50.4319 23.7059C57.2759 33.2035 49.3292 41.754 51.544 42.628C53.7588 43.5021 63.1049 29.2809 60.6503 23.378Z",
    fill: "#22D758"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9493 23.378C13.913 18.6558 20.4127 21.3091 22.1677 23.7059C15.3238 33.2035 23.2705 41.754 21.0557 42.628C18.8409 43.5021 9.49478 29.2809 11.9493 23.378Z",
    fill: "#22D758"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4697 24.7259C57.8252 20.8441 52.3129 23.0532 50.8635 25.0149C56.5735 32.8311 50.0038 39.8244 51.8449 40.5486C53.6859 41.2728 61.5252 29.5782 59.4697 24.7259Z",
    fill: "#22D758"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1301 24.7259C14.7745 20.8441 20.2869 23.0532 21.7362 25.0149C16.0262 32.8311 22.5959 39.8244 20.7549 40.5486C18.9138 41.2728 11.0745 29.5782 13.1301 24.7259Z",
    fill: "#22D758"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4738 38.3554C57.4738 49.0577 60.0894 57.7335 35.7056 57.7335C11.3217 57.7335 13.9375 49.0577 13.9375 38.3554C13.9375 27.6532 23.6834 18.9774 35.7056 18.9774C47.7279 18.9774 57.4738 23.8219 57.4738 38.3554Z",
    fill: "#0E6628"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2393 21.6402C34.7452 16.8313 48.2357 17.0844 48.6573 17C44.8125 17.9449 44.2448 22.287 44.4415 24.34C40.8722 25.043 33.8346 25.4874 34.2393 21.6402Z",
    fill: "#0E6628"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7224 24.2509C36.2283 19.5028 49.7187 19.7527 50.1403 19.6694C46.2955 20.6024 45.7278 24.8895 45.9245 26.9165C42.3552 27.6107 35.3176 28.0494 35.7224 24.2509Z",
    fill: "#0E6628"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2411,
    cy: 35.2411,
    rx: 8.84867,
    ry: 6.97018,
    fill: "#179B3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4502 43.6C19.4629 42.7229 19.4348 37.8372 19.2941 35.5039C25.2859 27.4079 48.1556 30.1909 51.3624 32.1306C54.5692 34.0702 52.1219 40.3953 53.3034 41.829C54.4848 43.2626 57.3541 47.395 50.2653 52.8767C43.1765 58.3584 23.7427 55.4596 20.6778 52.8767C17.1189 49.8776 17.1844 44.6963 18.4502 43.6Z",
    fill: "#179B3E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.892,
    cy: 45.1773,
    rx: 3.55924,
    ry: 1.58188,
    fill: "#22D758"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9724,
    cy: 33.5109,
    rx: 9.63961,
    ry: 7.41509,
    fill: "#179B3E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9985 30.0026C29.3703 30.054 29.6575 30.3557 29.6846 30.7276C29.7252 31.2902 28.8237 31.5745 28.2568 31.6085L24.7723 32.0446C24.7723 32.0446 26.1673 29.6107 28.9989 30.0027L28.9985 30.0026Z",
    fill: "#22D758"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6295 29.2117C42.2576 29.2632 41.9705 29.5649 41.9434 29.9367C41.9028 30.4993 42.8043 30.7836 43.3712 30.8176L46.8556 31.2537C46.8556 31.2537 45.4607 28.8198 42.6291 29.2118L42.6295 29.2117Z",
    fill: "#22D758"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3758 44.3937C29.641 44.3745 31.4495 41.6219 31.415 38.2455C31.3806 34.869 29.5163 32.1474 27.251 32.1665C24.9858 32.1857 23.1773 34.9383 23.2118 38.3147C23.2462 41.6912 25.1105 44.4128 27.3758 44.3937Z",
    fill: "#22D758"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.381 43.6028C46.6463 43.5836 48.4547 40.831 48.4203 37.4546C48.3858 34.0781 46.5215 31.3565 44.2563 31.3756C41.991 31.3948 40.1826 34.1474 40.217 37.5238C40.2515 40.9003 42.1157 43.6219 44.381 43.6028Z",
    fill: "#22D758"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3533 42.1814C28.7991 42.1692 29.9533 40.4124 29.9313 38.2575C29.9094 36.1025 28.7195 34.3655 27.2737 34.3777C25.8279 34.3899 24.6736 36.1468 24.6956 38.3017C24.7176 40.4566 25.9075 42.1936 27.3533 42.1814Z",
    fill: "#FCFCFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3585 41.3905C45.8043 41.3783 46.9585 39.6214 46.9365 37.4665C46.9145 35.3116 45.7247 33.5746 44.2789 33.5868C42.8331 33.599 41.6788 35.3558 41.7008 37.5107C41.7228 39.6657 42.9127 41.4027 44.3585 41.3905Z",
    fill: "#FCFCFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3486 38.8787C28.4097 38.8698 29.264 38.2808 29.2567 37.5632C29.2494 36.8457 28.3832 36.2713 27.3221 36.2802C26.2609 36.2892 25.4066 36.8781 25.4139 37.5957C25.4213 38.3133 26.2874 38.8877 27.3486 38.8787Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3538 38.0878C45.415 38.0789 46.2693 37.4899 46.2619 36.7723C46.2546 36.0548 45.3885 35.4804 44.3273 35.4893C43.2662 35.4983 42.4119 36.0872 42.4192 36.8048C42.4265 37.5224 43.2927 38.0968 44.3538 38.0878Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5207 37.9875C26.8155 37.985 27.0522 37.7592 27.0494 37.4831C27.0466 37.207 26.8053 36.9853 26.5105 36.9877C26.2157 36.9902 25.979 37.216 25.9818 37.4921C25.9847 37.7682 26.2259 37.99 26.5207 37.9875Z",
    fill: "#FCFCFC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.526 37.1965C43.8208 37.194 44.0575 36.9682 44.0547 36.6921C44.0519 36.416 43.8106 36.1942 43.5158 36.1967C43.221 36.1992 42.9843 36.425 42.9872 36.7011C42.99 36.9772 43.2312 37.199 43.526 37.1965Z",
    fill: "#FCFCFC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9484 38.234C29.9251 36.0638 28.7242 34.3136 27.2664 34.3254C25.8082 34.337 24.6449 36.1062 24.6682 38.2764C24.6682 38.2764 26.1784 37.113 27.3389 37.1635C28.8864 37.2306 29.9485 38.2336 29.9485 38.2336L29.9484 38.234Z",
    fill: "#179B3E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9537 37.4431C46.9303 35.2728 45.7294 33.5226 44.2716 33.5344C42.8134 33.5461 41.6502 35.3152 41.6735 37.4855C41.6735 37.4855 43.1836 36.322 44.3441 36.3725C45.8917 36.4396 46.9538 37.4427 46.9538 37.4427L46.9537 37.4431Z",
    fill: "#179B3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.0fa92941.svg";
export { ForwardRef as ReactComponent };